import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[var(--border)] mt-16">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col items-center gap-6 text-center sm:text-left sm:flex-row sm:justify-between sm:gap-4">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-[var(--text-secondary)]">
              Ancient Wisdom Audio Library &copy; {currentYear} &middot; A <a href="https://spirit.charsoft.ai" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent-primary)] underline transition-all">Charsoft Spiritual App</a>
            </p>
            <p className="text-xs text-[var(--text-muted)] max-w-xl leading-relaxed">
              Artwork and modern translation renderings &copy; {currentYear} Charsoft Consulting. All original historical source texts are in the public domain.
            </p>
          </div>
          <p className="text-sm text-[var(--text-muted)] self-center sm:self-end">
            Made with 🌿 in Leesburg, VA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
